import { RootState } from "../../../rootState";

export const getOutputFormatsSelector = (state: RootState): string[] => {
    return state.gisServerCapabilities.receivedData
        ? state.gisServerCapabilities.receivedData?.["wfs:WFS_Capabilities"]!["ows:OperationsMetadata"][
              "ows:Operation"
          ].filter((operation) => operation.$.name === "GetFeature")[0]
              ["ows:Parameter"].filter((operation) => operation.$.name === "outputFormat")[0]
              ["ows:AllowedValues"]["ows:Value"].filter((value: string) => value != "application/gml+xml; version=3.2")
        : [];
};
